import { CommunityShotItem } from 'types/community';
import { useRive } from '@rive-app/react-webgl2';
import { communityOpenInRive } from 'lib/analytics';
import styles from './OpenInRiveCommunityButton.module.css';
import {
  RiveFileProp,
  RiveFilesContext,
} from 'contexts/riveFile/RiveFilesContext';
import { useContext } from 'react';

type Props = {
  shotItem: CommunityShotItem;
};

const OpenInRiveCommunityButton = ({ shotItem }: Props) => {
  const baseUrl = `${process.env.NEXT_PUBLIC_EDITOR}/preview`;
  const { slug, revisionId, communityPostId, title, fileId } = shotItem;

  function onClick() {
    communityOpenInRive(communityPostId, slug, title, fileId);
  }

  const uriArtboard = encodeURIComponent(shotItem.artboard);
  const uriAnimation = encodeURIComponent(shotItem.animation);
  const queryString = `mode=animate&artboard=${uriArtboard}&animation=${uriAnimation}`;

  return (
    <a
      className={styles.Container}
      href={`${baseUrl}/${slug}/${revisionId}?${queryString}`}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
    >
      Preview in Rive
      <div className={styles.Icon}>
        <PopoutAnimation />
      </div>
    </a>
  );
};

function PopoutAnimation() {
  const { popout } = useContext(RiveFilesContext);
  // @ts-ignore
  if (popout == null || popout?.buffer === undefined) {
    return <></>;
  }
  return <_PopoutAnimation riveFile={popout} />;
}

function _PopoutAnimation({ riveFile }: RiveFileProp) {
  const { RiveComponent } = useRive({ riveFile, autoplay: true });
  return <RiveComponent />;
}

export default OpenInRiveCommunityButton;
